import Dropdown from "../../Settings/Dropdown";
import { RANGE_OPTIONS, RangePreset } from "./usageTypes";

interface Props {
  preset: RangePreset;
  from: string;
  to: string;
  onPreset: (p: RangePreset) => void;
  onCustom: (from: string, to: string) => void;
}

export default function DateRangeControl({ preset, from, to, onPreset, onCustom }: Props) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Dropdown
        dense
        size="sm"
        options={RANGE_OPTIONS}
        value={preset}
        onChange={(v) => onPreset(v as RangePreset)}
        menuAlign="start"
        id="usage-range"
      />
      {preset === "custom" ? (
        <div className="flex items-center gap-2 text-sm">
          <input
            type="date"
            aria-label="From date"
            className="input input-bordered input-sm bg-base-100"
            value={from}
            max={to}
            onChange={(e) => e.target.value && onCustom(e.target.value, to)}
          />
          <span className="text-base-content/50">to</span>
          <input
            type="date"
            aria-label="To date"
            className="input input-bordered input-sm bg-base-100"
            value={to}
            min={from}
            onChange={(e) => e.target.value && onCustom(from, e.target.value)}
          />
        </div>
      ) : (
        <span className="text-xs text-base-content/50 tabular-nums">
          {from} to {to}
        </span>
      )}
    </div>
  );
}
